import { SpTooltip } from 'components/shared/Tooltip/Tooltip';
import { FormattedMessage } from 'react-intl';

type SuccessfulPriceButtonProps = {
  label: string;
  confidence: number;
  isDisplayedPrice: boolean;
  onClick: () => void;
};

const SuccessfulPriceButton = ({ label, confidence, isDisplayedPrice, onClick }: SuccessfulPriceButtonProps) => {
  return (
    <div className="price-button-container py-1">
      <button
        className={`position-relative btn btn-${isDisplayedPrice ? 'discreet' : 'flat'}-buy btn-icon-end flex-x justify-content-between w-100 fw-semibold`}
        onClick={onClick}
      >
        <span className="text-nowrap lh-1">
          {isDisplayedPrice ? label : <FormattedMessage id="smartQuote.workspace.main.priceButton.defaultLabel" />}
        </span>
        <SpTooltip
          contents={
            <FormattedMessage
              id="smartQuote.workspace.main.priceButton.confidence.tooltipLabel"
              values={{ confidence }}
            />
          }
          position="top"
          color="secondary"
        >
          <div className="ai-rating">
            <svg width="20" height="20" viewBox="0 0 40 40">
              <circle
                className="donut-ring"
                cx="20"
                cy="20"
                r="15.91549430918954"
                fill="transparent"
                strokeWidth="2"
              ></circle>
              <circle
                className="donut-segment"
                cx="20"
                cy="20"
                r="15.91549430918954"
                fill="transparent"
                strokeWidth="2"
                strokeDasharray={`${confidence} ${100 - confidence}`}
                strokeDashoffset="25"
              ></circle>
              <g className="donut-text">
                <text x="50%" y="50%" className="donut-percent fw-medium">
                  {Math.round(confidence)}
                </text>
              </g>
            </svg>
          </div>
        </SpTooltip>
      </button>
    </div>
  );
};

export default SuccessfulPriceButton;
